import ScrollHint from 'scroll-hint';
new ScrollHint('.house_vacancy_r2',{
  suggestiveShadow: true
});